module.exports = __webpack_public_path__ + "img/ratio.b9d17835.png";